import './style.scss';

import content from 'content.json';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

const { modal } = content;

const ResetConfirmation: FC = () => (
    <span className="reset-confirmation">
        <Modal.Header closeButton>
            <Modal.Title>{modal.reset.confirmation}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <p>
                {modal.reset.confirmationText}
                <a href="mailto:hello@wishi.me">{modal.reset.email}</a>
            </p>
        </Modal.Body>
    </span>
);
export default ResetConfirmation;
